
import Vue from "vue";

export interface ActionButtonProps {
  text: string;
  iconSrc?: string;
  iconClickable?: boolean;
}

export default Vue.extend({
  name: "ActionButton",
  props: {
    text: {
      type: String,
      required: true,
    },
    iconSrc: {
      type: String,
      required: false,
    },
    iconClickable: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    handleClick(): void {
      this.$emit("click", this.text);
    },
    handleIconClick(): void {
      this.$emit("icon-click");
    },
  },
});
